
(() => {
  if (customElements.get('ls-halloween-splash')) return;
  class HalloweenSplash extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.view = this.querySelector('.ls-halloween-view');
      this.template = this.querySelector('[data-game-document]');
      this.key = 'liquid-sky-halloween-2026-v1';
      this.previousOverflow = '';
      this.onMessage = event => {
        if (event.source !== this.frame?.contentWindow || event.origin !== location.origin) return;
        if (event.data?.type === 'ls-halloween-shop') this.dismiss(true);
        if (event.data?.type === 'ls-halloween-fullscreen') this.fullscreen();
      };
      this.onClick = event => {
        if (event.target.closest('[data-open-halloween]')) this.openGame();
        if (event.target.closest('[data-skip-halloween]')) this.dismiss(true);
        if (event.target.closest('[data-shop-link]')) { event.preventDefault(); this.enterShop(); }
      };
      this.onCancel = event => { event.preventDefault(); this.dismiss(true); };
      this.onClose = () => { if (!this.dialog.open) this.cleanup(); };
      this.onUnload = event => { if (event.target.contains(this)) this.dismiss(false); };
      this.addEventListener('click', this.onClick);
      this.dialog.addEventListener('cancel', this.onCancel);
      this.dialog.addEventListener('close', this.onClose);
      window.addEventListener('message', this.onMessage);
      document.addEventListener('shopify:section:unload', this.onUnload);
      this.querySelector('[data-halloween-bar]').hidden = false;
      let seen = false;
      try { seen = sessionStorage.getItem(this.key) === 'dismissed'; } catch {}
      if (!window.Shopify?.designMode && !(this.dataset.showOnce === 'true' && seen)) this.openGame();
    }
    openGame() {
      if (this.dialog.open || !this.dialog.showModal) return;
      this.previousFocus = document.activeElement;
      this.previousOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      try { this.dialog.showModal(); } catch { this.cleanup(); return; }
      this.frame = document.createElement('iframe');
      this.frame.className = 'ls-halloween-frame';
      this.frame.title = 'Liquid Sky Halloween — 60 second playable adventure';
      this.frame.allow = 'autoplay; fullscreen';
      this.frame.allowFullscreen = true;
      this.frame.srcdoc = this.template.content.textContent;
      this.view.append(this.frame);
      this.dialog.querySelector('[data-skip-halloween]').focus({ preventScroll: true });
    }
    async fullscreen() {
      try { if (document.fullscreenElement) await document.exitFullscreen(); else await this.view.requestFullscreen(); } catch {}
    }
    cleanup() {
      this.frame?.remove();
      this.frame = null;
      document.documentElement.style.overflow = this.previousOverflow;
    }
    dismiss(goToProducts) {
      try { sessionStorage.setItem(this.key, 'dismissed'); } catch {}
      if (document.fullscreenElement === this.view) document.exitFullscreen().catch(() => {});
      this.cleanup();
      if (this.dialog.open) this.dialog.close();
      if (goToProducts) this.enterShop();
    }
    enterShop() {
      const products = document.querySelector('#MainContent .featured-collection');
      if (!products) { location.assign(this.dataset.shopUrl); return; }
      const target = products.querySelector('h2') || products;
      target.setAttribute('tabindex', '-1');
      requestAnimationFrame(() => {
        products.scrollIntoView({ behavior: 'instant', block: 'start' });
        target.focus({ preventScroll: true });
      });
    }
    disconnectedCallback() {
      this.cleanup();
      this.removeEventListener('click', this.onClick);
      this.dialog?.removeEventListener('cancel', this.onCancel);
      this.dialog?.removeEventListener('close', this.onClose);
      window.removeEventListener('message', this.onMessage);
      document.removeEventListener('shopify:section:unload', this.onUnload);
    }
  }
  customElements.define('ls-halloween-splash', HalloweenSplash);
})();
